<template>
  <div>
    <v-tabs
      :class="[$route.name === 'ticket3-agent-sale-performance' ? 'mb-0' : 'mb-4']"
      :slider-color="$vuetify.theme.primary"
      color="#eee"
    >
      <v-tab :to="{ name: 'ticket3-agent-performance-detail' }">Agent Performance</v-tab>
      <v-tab :to="{ name: 'ticket3-agent-performance-summary' }">Agent Performance Summary</v-tab>
      <v-tab
        v-if="isAllInOneChatWithTicketSaleConversation"
        :to="{ name: 'ticket3-agent-sale-performance' }"
        >Agent Sale Performance
      </v-tab>
      <v-tab v-if="isHotstar" :to="{ name: 'ticket3-agent-work-time' }">Agent Work Time</v-tab>
    </v-tabs>

    <v-container
      :style="{
        width: $route.name === 'ticket3-agent-sale-performance' ? '100% !important' : '',
        padding: $route.name === 'ticket3-agent-sale-performance' ? '0px !important' : ''
      }"
      fluid
    >
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page'
import { FEATURE } from '@/constants/feature.js'

export default {
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    isHotstar() {
      return PAGE.HOTSTAR.includes(this.selectedBot.pageid)
    },
    isAllInOneChatWithTicketSaleConversation() {
      return (this.selectedBot.features || '')
        .split(',')
        .includes(FEATURE.ALL_IN_ONE_CHAT_WITH_TICKET_SALE_CONVERSION)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/AgentPerformance.vue